import { connect, MapStateToProps } from "react-redux";

import { createOpenFormModalAction } from "@multiweb/reactCore/bridge";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { ReportingScalarProvider, ReportingScalarProviderProps } from "../ReportingScalarProvider";
import { ControlComponentProps } from "../types";
import { createClearAction, createInitAction } from "./action";
import { getAggregationValue } from "./selectors";

export type ReportingScalarProps = {
    /** Localization key of description */
    readonly secondaryLC?: string;
} & Omit<ReportingScalarProviderProps, "value" | "loadData" | "clearData" | "createOpenFormModalAction"> & ControlComponentProps;

type StateProps = Pick<ReportingScalarProviderProps, "value" | "caption" | "description">;

const mapStateToProps: MapStateToProps<StateProps, ReportingScalarProps, IAppState> = (state, { dataKey, locKey, caption, secondaryLC, description }) => ({
    value: getAggregationValue(state, dataKey),
    caption: locKey ? getPrimaryText(state, locKey) : caption,
    description: secondaryLC ? getPrimaryText(state, secondaryLC) : description,
});

type DispatchProps = Pick<ReportingScalarProviderProps, "loadData" | "createOpenFormModalAction" | "clearData">;

const mapDispatchToProps: DispatchProps = {
    loadData: createInitAction,
    createOpenFormModalAction,
    clearData: createClearAction,
};

export const ReportingScalar = connect(mapStateToProps, mapDispatchToProps)(ReportingScalarProvider);
